import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppNotification } from '@fuse/types/notification';
import { AuthService } from '../auth/auth.service';
import { timer } from 'rxjs';
import { Router } from '@angular/router';

export interface IsNewResponse {
    data: number;
}

@Injectable()

export class NotificationsService implements OnDestroy {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;

    timer: Observable<number>;
    timerSubscription: Subscription;

    onNotificationsChanged: BehaviorSubject<any>;
    newNotifications: Subject<AppNotification[]>;
    allNotificationsChanged: Subject<any>;

    newNotificationsCount = 0;

    currentData = [];

    fromNotifications = false;

    searchText: string;

    constructor(
        public _http: HttpClient,
        private _authService: AuthService,
        private _router: Router
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();

        this.onNotificationsChanged = new BehaviorSubject([]);
        this.newNotifications = new Subject();
        this.allNotificationsChanged = new Subject();

        if (this._authService.isAuthenticated()) {
            this.subscribeToNotifications();
        }

        this._authService.userSetComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((data) => {
                if (data) {
                    this.subscribeToNotifications();
                } else {
                    this.timerSubscription.unsubscribe();
                }
            });

        this._authService.logoutComplete.subscribe(() => {
            this.timerSubscription.unsubscribe();
        });
    }

    /**
     * Public methods
     */

    subscribeToNotifications(): void {
        this.timer = timer(0, 60000);
        this.timerSubscription = this.timer
            .subscribe(() => {
                if (this._authService.isAuthenticated()) {
                    this.checkNewNotificationCount();
                }
            });
    }

    toolbarListClick(): void {
        this.fromNotifications = true;
        this._router.navigate(['/notifications']);
    }

    public checkNewNotificationCount(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.get<IsNewResponse>(this._fuseConfig.api.url + '/portal/notification/is-new')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.onNotificationsChanged.next(response.data);
                        if (response.data !== this.newNotificationsCount) {
                            this.newNotificationsCount = response.data;
                            this.checkNewNotifications();
                        }
                        resolve(response);
                    }, reject);
        });
    }

    public checkNewNotifications(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._http.get<AppNotification[]>(this._fuseConfig.api.url + '/portal/notification/get-new')
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        // this.onNotificationsChanged.next(response.data);
                        console.log(response);
                        this.newNotifications.next(response);
                        resolve(response);
                    }, reject);
        });
    }

    public getAllNotifications(): Observable<AppNotification[]> {
        return this._http.get<AppNotification[]>(this._fuseConfig.api.url + '/portal/notification/get-all');
    }


    public listAllNotifications(page: number = 1, limit: number = 10, orderBy: string = 'created_at', order: string = 'desc', search: string = ''): Promise<any> {

        const params = {
            limit: limit,
            order_by: orderBy,
            order: order
        };

        return new Promise((resolve, reject) => {
            this._http.post(this._fuseConfig.api.url + '/portal/notification/listing?page=' + page, params)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        this.allNotificationsChanged.next(response);
                        resolve(response);
                    }, reject);
        });

    }

    public markAsRead(id: string): Promise<any> {

        return new Promise((resolve, reject) => {
            this._http.get(this._fuseConfig.api.url + '/portal/notification/mark-as-read/' + id)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    response => {
                        // this.listAllNotifications();
                        this.checkNewNotificationCount();
                        resolve(response);
                    }, reject);
        });

    }

    /**
     * Lifecycle hooks
     */

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
